export default "__VITE_ASSET__yV92nsya__"